import getDistance from "levenshtein-lite";

const supportedEmailClients = [
  "aol.com",
  "gmail.com",
  "hotmail.com",
  "outlook.com",
  "yahoo.com"
];

const querySuggestedEmail = testEmail => {
  let suggestedClient;
  const [testPrefix, testClient] = testEmail.split("@");

  supportedEmailClients.forEach(client => {
    const distanceToClient = getDistance(testClient, client);
    if (distanceToClient > 0 && distanceToClient <= 2) {
      suggestedClient = client;
    }
  });

  if (suggestedClient) {
    return `${testPrefix}@${suggestedClient}`;
  }

  return false;
};

export default querySuggestedEmail;
